import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const MasterDataConversionTables = () => {
	return <PlaceholderView pageType={PageType.MasterDataConversionTables} text="Conversion Tables" />;
};

export default MasterDataConversionTables;
